export const parseNewCmsData = ({ data}) => {
    const {
        testimonialList = [],
        bannerList = [],
        heroMobileImage = {},
        heroDesktopImage = {},
        faqList = [],
        offerList = [],
        heroImageTitle = "",
        heroImageSubTitleList = [],
        bannerTitle = "",
        brandTitle = "",
        whycars24 = {},
        buyerTestimonialList = [],
        testimonialsTitle = "",
        videoList = [],
        rating = {},
        appDownload = {},
        footerBanner = {},
        buyerTestimonialTitle,
        offerTitle,
        faqTitle,
        primaryContent = [],
        primaryContentTitle = "",
        primaryDescription = "",
        primaryContentSubtitle = "",
        primaryContentImage = {},
        journeyList = [],
        journeyTitle = "",
        journeyImage = {},
        ownershipList = [],
        ownershipTitle = "",
        ownershipSubTitle = "",
        ownershipDescription = "",
        ownershipMobileBackground = {},
        ownershipDesktopBackground = {},
        heroImageSubTitle = "",
        heroAppImage = {},
        testimonialTitle = "",
        deliveryTitle = "",
        deliveryList = [],
        bannerSubTitle = "",
        videoTitle = "",
        videoUrl = "",
        videoThumbnail = "",
        videoDescription = "",
        metaTitle = "",
        metaDescription = "",
        seoContent = {},
        download = {},
        factList = [],
        factTitle = "",
        carTypeTitle = "",
        carTypeList = [],
        breadcrumb = [],
        secondaryContentTitle = "",
        secondaryContent = [],
        heroImageDescription = {},
        ogTitle = "",
        ogDescription = ""
    } = data || {};
    return {
        cmsData: {
            faqList,
            offerList,
            highlightsTitle: bannerTitle,
            testimonialList,
            brandTitle,
            whycars24,
            socialTestimonials: buyerTestimonialList,
            testimonialsTitle,
            rating,
            appDownload,
            footerBanner,
            bannerList,
            buyerTestimonialTitle,
            offerTitle,
            faqTitle,
            primaryContent,
            primaryContentTitle,
            primaryDescription,
            primaryContentSubtitle,
            primaryContentImage,
            journeyList,
            journeyTitle,
            journeyImage,
            ownershipList,
            ownershipTitle,
            ownershipSubTitle,
            ownershipDescription,
            ownershipMobileBackground,
            ownershipDesktopBackground,
            heroImageSubTitle,
            heroAppImage,
            testimonialTitle,
            deliveryTitle,
            deliveryList,
            bannerSubTitle,
            videoTitle,
            videoUrl,
            videoThumbnail,
            videoDescription,
            videoList,
            metaTitle,
            metaDescription,
            download,
            factList,
            factTitle,
            carTypeTitle,
            carTypeList,
            breadcrumb,
            secondaryContentTitle,
            secondaryContent,
            heroImageDescription,
            heroMobileImage,
            heroImageTitle,
            heroDesktopImage,
            heroImageSubTitleList,
            seoContent,
            ogTitle,
            ogDescription
        }
    };
};
